module.exports = __webpack_public_path__ + "img/index-qysl7.2bcc2063.png";